import type { TrialAssociation } from '@modules/trials/types/TrialAssociation'
import { TrialOverridesTypeValidator } from '@modules/trials/types/TrialOverrides'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

export const AdditionalInformation = ({
  trial,
}: {
  trial: TrialAssociation
}) => {
  const trialOverridesResult = TrialOverridesTypeValidator.safeParse(
    trial.overrides,
  )

  if (
    !trialOverridesResult.success ||
    !trialOverridesResult.data.timeline?.additionalInfo
  ) {
    return null
  }

  return (
    <div className='mb-8'>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {trialOverridesResult.data.timeline?.additionalInfo}
      </ReactMarkdown>
    </div>
  )
}
